import Handlebars from 'handlebars/runtime';
// TODO: Define exisiting helpers
// import checkLength from '../_helpers/checkLength';
import contains from '../_helpers/contains'
import removeMarkup from '../_helpers/removeMarkup'
import ifEquals from '../_helpers/ifEquals'
import truncateNumber from '../_helpers/truncateNumber'
import convertBytes from '../_helpers/convertBytes'
import lowercase from '../_helpers/lowercase'
import dollarsToCents from '../_helpers/dollarsToCents'
import checkLength from '../_helpers/checkLength'
import dateCloserThan from '../_helpers/dateCloserThan'
import formatDate from '../_helpers/formatDate'
import paginate from '../_helpers/paginate'
import ifGreaterThan from '../_helpers/ifGreaterThan'
import ifLessThan from '../_helpers/ifLessThan'

// TODO: Define exisiting partials
// import menuItemsHtml from '../menu/menuItems.partial.hbs'
import gHeaderNavItemHtml from '../gHeader/gHeaderNavItem.partial.hbs'
import categoryListTileHtml from '../categoryList/categoryListTile.partial.hbs'
import savedForLaterHtml from '../cart/savedForLater.partial.hbs'
import shippingAddressFormPartialHtml from '../shipping/shippingAddressForm.partial.hbs'
import spdcLogoHtml from '../_svgs/spdcLogo.partial.hbs'
import spdcLogomarkHtml from '../_svgs/spdcLogomark.partial.hbs'
import customQuoteRowHtml from '../customQuote/customQuoteRow.partial.hbs'

// TODO: Register exisiting helpers
// Handlebars.registerHelper('checkLength', checkLength);
Handlebars.registerHelper('contains', contains);
Handlebars.registerHelper('removeMarkup', removeMarkup);
Handlebars.registerHelper('ifEquals', ifEquals);
Handlebars.registerHelper('truncateNumber', truncateNumber);
Handlebars.registerHelper('convertBytes', convertBytes);
Handlebars.registerHelper('lowercase', lowercase);
Handlebars.registerHelper('dollarsToCents', dollarsToCents);
Handlebars.registerHelper('checkLength', checkLength);
Handlebars.registerHelper('dateCloserThan', dateCloserThan);
Handlebars.registerHelper('formatDate', formatDate);
Handlebars.registerHelper('paginate', paginate);
Handlebars.registerHelper('ifGreaterThan', ifGreaterThan);
Handlebars.registerHelper('ifLessThan', ifLessThan);

// TODO: Register exisiting partials
// Handlebars.registerPartial('menuItems', menuItemsHtml);
Handlebars.registerPartial('gHeaderNavItem', gHeaderNavItemHtml);
Handlebars.registerPartial('categoryListTile', categoryListTileHtml);
Handlebars.registerPartial('savedForLater', savedForLaterHtml);
Handlebars.registerPartial('shippingAddressForm', shippingAddressFormPartialHtml);
Handlebars.registerPartial('spdcLogo', spdcLogoHtml);
Handlebars.registerPartial('spdcLogomark', spdcLogomarkHtml);
Handlebars.registerPartial('customQuoteRow', customQuoteRowHtml);

export default Handlebars;